var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 -6.99382e-07C12.4235 -3.12665e-07 16 3.57647 16 8C16 12.4235 12.4235 16 8 16C3.57647 16 3.12665e-07 12.4235 6.99382e-07 8C1.0861e-06 3.57647 3.57647 -1.0861e-06 8 -6.99382e-07ZM8 15.0588C11.9059 15.0588 15.0588 11.9059 15.0588 8C15.0588 4.09412 11.9059 0.941176 8 0.941176C4.09412 0.941175 0.941177 4.09412 0.941177 8C0.941177 11.9059 4.09412 15.0588 8 15.0588Z",
    fill: "#ABA7AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09421 7.20018L8.00009 11.1061L11.906 7.20018L12.5648 7.85901L8.00009 12.4237L3.43539 7.85901L4.09421 7.20018Z",
    fill: "#ABA7AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47059 11.7647L7.52941 11.7647L7.52941 3.7647L8.47059 3.7647L8.47059 11.7647Z",
    fill: "#ABA7AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownDisable);
export default __webpack_public_path__ + "static/media/DownDisable.6153ef56cc00310c02dad80cd3471ad6.svg";
export { ForwardRef as ReactComponent };